import type { User } from 'firebase/auth';

import { auth } from '../firebaseAuth';
import { getBrowserVerificationHeaders } from './appCheck';
import { AUTH_STAGE_TIMEOUT_MS, runAuthStage } from './authTelemetry';

/**
 * Returns headers that include a Firebase ID token for authenticated requests.
 * Throws if the user is not signed in or the token cannot be retrieved.
 */
export async function getAuthHeaders(
  user?: User | null,
  forceRefresh = false,
): Promise<Record<string, string>> {
  const resolvedUser = user ?? auth.currentUser;
  if (!resolvedUser) {
    throw new Error('You must be signed in to perform this action.');
  }

  const token = await runAuthStage(
    'token_retrieval',
    () => resolvedUser.getIdToken(forceRefresh),
    { timeoutMs: AUTH_STAGE_TIMEOUT_MS.token, successSampleRate: 0.05 },
  );
  if (!token) {
    throw new Error('Unable to retrieve your session. Please sign in again.');
  }

  return {
    Authorization: `Bearer ${token}`,
    ...await getBrowserVerificationHeaders(),
  };
}
